export const environment = {
  production: false,
  API_URL: 'https://api.sandbox.rtt.in.th/v3',
  API_VTT: 'https://api-prcc.sandbox.rtt.in.th',
  API_SHELTER: 'https://api.sandbox.rtt.in.th/shelter/v2',
  MEDIA: 'https://shelter.sandbox.rtt.in.th/media',
  API_ASSETS: 'https://assets.sandbox.rtt.in.th',
  API_MANAGEMENT: 'https://management-api.sandbox.rtt.in.th/v1',
  OAUTH: {
    URL: 'https://accounts.sandbox.rtt.in.th/auth/realms/rtt',
    CLIENT_ID: 'shelter',
    RESONSE_TYPE: 'code'
  },
  ROOM_TYPE: [
    "unknow",
    "ห้องถ่ายทอดสด",
    "ห้องฝึกพิมพ์กับบอท",
    "ห้องสำหรับทดสอบ (ไม่เก็บ Log)",
    "ห้องรีเพลย์ (แบบไม่วนซ้ำ)",
    "ห้องรีเพลย์ (แบบวนซ้ำ)",
    "ห้องพูดทวน",
    "Bot แบ่งพิมพ์",
    "ASR",
    "Bot แบ่งพิมพ์",
    "Bot ASR",
    "Bot พูดทวน"
  ],
  POSTEDIT_TYPE: [
    "unknow",
    "Reserved",// Watch Detail
    "Waiting", // Watch Detail
    "Ready", // GO to PE, end
    "EOS", //
    "Idle", // 
    "End", // Watch Detail
  ],

};
